import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import PropTypes from 'prop-types';
import {
 ArrowLeft, ArrowRight, DotSelected, DotUnselected,
} from '../../../shared/svg/components';
import { setPopupState, updateCurrentCameraShot } from '../../../model/configuratorSlice';
import { PopupState } from '../../../model/constants';

const PlayerControls = ({ isMobileLandscape }) => {
  const {
 currentShot, currentShots, currentCameras, isGeneralShot,
} = useSelector(state => state.configurator);
  const dispatch = useDispatch();
  const [selectedShot, setSelectedShot] = useState(0);
  const [leftArrowEnabled, setLeftArrowEnabled] = useState(false);
  const [rightArrowEnabled, setRightArrowEnabled] = useState(false);

  const updateSelectedShot = (countShot) => {
    setSelectedShot(countShot);
  };

  const updateArrows = (countShot) => {
    setLeftArrowEnabled(countShot > 0);
    setRightArrowEnabled(countShot < currentShots.length - 1);
  };

  useEffect(() => {
    let countShots = 0;
    currentShots.forEach((shot) => {
      if (shot === currentShot) {
        updateSelectedShot(countShots);
        updateArrows(countShots);
      }
      countShots += 1;
    });
  }, [currentShot, currentShots]);

  const leftArrowClicked = () => {
    const nextShot = currentShots[selectedShot - 1];
    const nextCamera = currentCameras[selectedShot - 1];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };
  const rightArrowClicked = () => {
    const nextShot = currentShots[selectedShot + 1];
    const nextCamera = currentCameras[selectedShot + 1];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };
  const dotClicked = (clickedDot) => {
    const nextShot = currentShots[clickedDot];
    const nextCamera = currentCameras[clickedDot];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };
  const handlers = useSwipeable({
    onSwipedLeft: eventData => rightArrowClicked(),
    onSwipedRight: eventData => leftArrowClicked(),
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const openLegalNoteHandler = () => {
    dispatch(setPopupState(PopupState.LegalNote));
  };

  return (
    <div className={`player-controls${isGeneralShot ? ' hide' : ''}`} {...handlers}>
      <button
        className={`arrow-left-button${leftArrowEnabled ? '' : ' disabled'}`}
        type="button"
        onClick={leftArrowClicked}
      >
        <ArrowLeft />
      </button>
      <button
        className={`arrow-right-button${rightArrowEnabled ? '' : ' disabled'}`}
        type="button"
        onClick={rightArrowClicked}
      >
        <ArrowRight />
      </button>
      <div className="dots">
        {currentShots.map((shot, index) => (
          <button
            className={`dot ${index === selectedShot ? 'selected' : ''}`}
            type="button"
            onClick={() => dotClicked(index)}
          >
            {index === selectedShot ? <DotSelected className="selected-color" /> : <DotUnselected />}
          </button>
        ))}
      </div>
      {!isMobileLandscape && (
        <button type="button" onClick={openLegalNoteHandler} className="legal-note">
          <span>Nota Legal</span>
        </button>
      )}
    </div>
  );
};

PlayerControls.propTypes = {
  isMobileLandscape: PropTypes.bool.isRequired,
};

export default PlayerControls;
